<template>
  <div>
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="medium"
        label-width="80px"
        :model="formInline"
        inline
      >
        <el-form-item prop="name" label="科目名称">
          <el-input
            v-model="formInline.name"
            placeholder="请输入科目名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>

      <div class="title">
        <el-button
          size="medium"
          type="primary"
          @click="openHandleAccount('add')"
          >新增科目</el-button
        >
      </div>

      <el-table
        border
        stripe
        v-loading="loading"
        :data="data"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="110" align="center">
        </el-table-column>
        <el-table-column label="科目名称" minWidth="260" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排序号" minWidth="230" align="center">
          <template slot-scope="{ row }">
            <div class="sort_box" v-if="row.isSelected">
              <span>{{ row.sortNum }}</span>
              <i
                @click="row.isSelected = !row.isSelected"
                class="el-icon-edit-outline cursor"
              ></i>
            </div>
            <div class="sort_box" v-else>
              <el-input
                v-model="row.sortNum"
                size="small"
                style="width: 100px; height: 36px"
                @input="row.sortNum = Number(row.sortNum) || 0"
                maxlength="3"
                placeholder="请输入内容"
                @blur="sortNumBlur(row)"
                v-focus
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="展示状态" minWidth="260" align="center">
          <template slot-scope="{ row }">
            <el-switch
              class="switchStyle"
              v-model="row.status"
              active-text="ON"
              inactive-text="OFF"
              :inactive-value="1"
              :active-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="switchChange(row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          minWidth="150"
          fixed="right"
          align="center"
          label="操作"
        >
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openHandleAccount('alter', row)"
              >编辑</span
            >
            <span class="blue_Box" @click="handleDelete(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 添加、编辑 -->
    <HandleAccount ref="handleAccountRef" />
  </div>
</template>

<script>
import {
  getBktSubjectListPage,
  delBktSubject,
  updateStatus,
  updateSortNum,
} from "@/api/videoReference/account.js";
import myPagination from "@/components/myPagination.vue";
import HandleAccount from "@/views/videoReference/components/handleAccount.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  components: {
    myPagination,
    HandleAccount,
  },
  mounted() {
    this.getBktSubjectListPage({ page: 1, limit: 10 });
  },
  data() {
    return {
      loading: false,
      formInline: {
        name: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
    };
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector("input").focus();
      },
    },
  },
  methods: {
    // 修改排序号
    sortNumBlur(payload) {
      payload.isSelected = !payload.isSelected;
      updateSortNum({ id: payload.id, sortNum: payload.sortNum }).then(
        (res) => {
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.refresh();
          }
        }
      );
    },
    // 修改科目状态
    switchChange(payload) {
      let str = payload.status === 2 ? "显示" : "隐藏";
      this.$confirm(`确认要${str}该科目吗, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateStatus({ id: payload.id, status: payload.status }).then(
            (res) => {
              if (res.code === 0) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
                this.refresh();
              }
            }
          );
        })
        .catch(() => {
          payload.status = payload.status === 1 ? 2 : 1;
        });
    },
    // 刷新
    refresh() {
      this.getBktSubjectListPage(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 列表请求
    async getBktSubjectListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getBktSubjectListPage(payload);
      let datas = res.data?.records || [];
      this.data = datas.map((item) => {
        return { ...item, isSelected: true };
      });
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 删除
    handleDelete(payload) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delBktSubject({ id: payload.id }).then((res) => {
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            if (this.pageInfo.total >= this.pageInfo.limit) {
              let sum = this.pageInfo.total % this.pageInfo.limit;
              if (sum === 1) {
                this.pageInfo.page =
                  Number(this.pageInfo.page) === 1
                    ? 1
                    : Number(this.pageInfo.page) - 1;
              }
            }
            this.refresh();
          }
        });
      });
    },
    // 添加、编辑
    openHandleAccount(status, payload) {
      this.$refs.handleAccountRef.init(status, payload);
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getBktSubjectListPage(
        Object.assign(processing(this.formInline), {
          page: 1,
          limit: 10,
        })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getBktSubjectListPage({
        page: 1,
        limit: 10,
      });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getBktSubjectListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getBktSubjectListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/index.scss";
.sort_box {
  width: 100%;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    margin-right: 6px;
  }
  .el-icon-edit-outline {
    font-size: 18px;
  }
}
</style>